export const getTaskPriorities = (state) => state.priorities
